export default [
  require('@/assets/images/job/placeholder/job1.png'),
  require('@/assets/images/job/placeholder/job2.png'),
  require('@/assets/images/job/placeholder/job3.png'),
  require('@/assets/images/job/placeholder/job4.png'),
  require('@/assets/images/job/placeholder/job5.png'),
  require('@/assets/images/job/placeholder/job6.png'),
  require('@/assets/images/job/placeholder/job7.png'),
  require('@/assets/images/job/placeholder/job8.png'),
];